import { Injectable } from '@angular/core';
import { ApiService } from './api';
import { catchError, of, tap } from 'rxjs';


export interface Session {
  data: SessionDetail;
  included?: any;
}

export interface SessionDetail {
  partner_id: string;
  user_id: number;
  partner_type?: string;
  partner_uid?: string;
  partner_carrier_code?: string;
  user_partner_uid?: string;
  user_partner_type?: string;
  user_carrier_code?: string;
}

export interface Creds {
  email: string;
  password: string;
}

@Injectable({ providedIn: 'root' })
export class SessionsService {
  path = '/api';

  constructor(
    private apiService: ApiService,
  ) { }

  /**
   * Fetch the current session.
   *
   * @param dataOnly  When `true` (default), prefer the cached `sessionData` from
   *                  `sessionStorage` and only round-trip to the backend on a
   *                  cache miss. When `false`, bypass the cache entirely and
   *                  force a fresh `GET /api/session` — required when state on
   *                  the server may have diverged (post-PUT, post-logout, etc).
   */
  getSession(dataOnly: boolean = true) {
    if (dataOnly) {
      const cached = window.sessionStorage.getItem('sessionData');
      if (cached) {
        return of(JSON.parse(cached));
      }
    }
    return this.apiService.get(`${this.path}/session`).pipe(
      tap((session: any) => {
        if (session?.data?.user_id) {
          window.sessionStorage.setItem('sessionData', JSON.stringify(session));
        }
      }),
      catchError((err) => {
        console.error('SessionsService: session fetch failed', err?.status);
        return of(null);
      })
    );
  }

  signInPartner(partnerId: number) {
    const data = {
      partner_id: partnerId,
    };
    return this.apiService.put(`${this.path}/session`, data).pipe(
      // Server-side session just changed — the cached client copy is stale.
      // Subsequent `getSession()` callers must re-read or they'll see the
      // pre-PUT partner state.
      tap(() => window.sessionStorage.removeItem('sessionData'))
    );
  }
}
